var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"sticky":"","variant":"light"}},[_c('b-button-group',[_c('ApiCredentials',{attrs:{"app-id":_vm.app.caveon_id}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }